import {h, Fragment} from "preact"
import { useFacets } from "@nosto/preact"
import Facet from "./Facet"
import RangeFacet from "./RangeFacet"
import Icon from "./elements/Icon"
import SelectedFilters from "./SelectedFilters"

function ToggleSidebarButton({ className }) {
    return (
        <label
            className={`ns-act-btn ns-close-sidebar ns-absolute ns-d-block ns-d-md-none ns-align-items-center ns-clickable ${className}`}
            for="toggle-mobile-sidebar"
        >
            {/* <Icon name="close" /> */}
            <svg class="Icon Icon--close" role="presentation" viewBox="0 0 16 14">
                <path d="M15 0L1 14m14 0L1 0" stroke="currentColor" fill="none" fill-rule="evenodd"></path>
            </svg>
        </label>
    )
}

export default function SideBar() {
    const { loading, facets } = useFacets()
    const isMobile = window.innerWidth < 769;

    return facets?.length > 0 ? (
        <>
            <label
                class="ns-sidebar-backdrop ns-fixed ns-w-100 ns-h-100 ns-background-black ns-d-none"
                for="toggle-mobile-sidebar"
            />
            <div
                class="ns-sidebar-wrapper ns-sidebar-wrapper--withTopToolbar ns-d-none ns-d-md-block"
                style={loading ? "opacity: 0.3;" : ""}
            >
                <div class="ns-sidebar-content ns-relative ns-background-white ns-h-100 ns-mr-0 ns-mr-md-auto">

                        <div class="ns-sidebar-header ns-d-md-none ns-d-flex">
                            <span class="ns-filters-header-mobile">Filters</span>
                            <ToggleSidebarButton />
                        </div>
              
                    <div class="ns-sidebar-menu">
                        <SelectedFilters />
                        <ul class="ns-list-unstyled ns-p-0 ns-m-0">
                            {facets?.map(facet => {
                                switch (facet.type) {
                                    case "terms":
                                        return <Facet facet={facet} />
                                    case "stats":
                                        return <RangeFacet facet={facet} />
                                    default:
                                        return null
                                }
                            })}
                        </ul>
                    </div>
                </div>
            </div>
        </>
    ) : (
        ""
    )
}
